import cx from "classnames";
import FieldWrapper from "../components/FieldWrapper";
import { SingleChoiceFieldType } from "../types/feedbackFields.types";
import { FieldValueProps } from "./fields.types";
import { withSingleValue } from "./fields.utils";

// TODO: handle required
const SingleChoiceField = ({
  field,
  value,
  error,
  onChange,
}: { field: SingleChoiceFieldType } & FieldValueProps<string>) => {
  const { _id, name, required, choices } = field;
  const id = _id || name;

  return (
    <FieldWrapper field={field} error={error}>
      <div id={id}>
        {choices.map((choice, index) => {
          const { type, value: choiceValue, text } = choice;

          if (type === "header") {
            return (
              <label key={index} style={{ fontWeight: "bold", fontSize: 14 }}>
                {choice.text}
              </label>
            );
          }
          const inputValue = choiceValue || text;
          return (
            <div key={index} className={cx("c-checkbox", field.choices.length >= 3 && "vertical")}>
              <label>
                <input
                  type="radio"
                  name={_id}
                  value={inputValue}
                  required={required}
                  checked={value === inputValue}
                  onChange={() => onChange(id, inputValue)}
                />
                {text}
              </label>
            </div>
          );
        })}
      </div>
    </FieldWrapper>
  );
};
export default withSingleValue(SingleChoiceField);
